import { Card } from "@/src/components/cards";
import { openDialog } from "@/src/components/dialogs";
import { DicomReception, FolderItem } from "@/src/data/allTypes";
import { getBackendUrl } from "@/src/utils/utils";

function DicomReceptionCard({
  dicomReception,
  parent,
  onAssign,
}: {
  dicomReception: DicomReception;
  parent: FolderItem | null | undefined;
  onAssign: (dicomReception: DicomReception) => void;
}) {
  return (
    <Card
      color="simple"
      onClick={async () => {
        openDialog({
            id: "dicomViewerDialog",
            title: "Visualiser le fichier",
            additionalClasses: ["noPadding"],
            content: (
              <iframe
                id="dicomIframe"
                src={`${getBackendUrl()}/dicom?filename=${dicomReception.filePath.split("/").pop()}`}
              ></iframe>
            ),
          });
        // onAssign(dicomReception);
      }}
      title={dicomReception.filePath}
      subTitle={dicomReception.type}
    ></Card>
  );
}

export default DicomReceptionCard;
